import { Form } from '../../../components';

const PlotsUpload = (props) => {
  function handleFormChange(e) {
    if (props.hasOwnProperty('onChange')) {
      props.onChange(e);
    }
  }

  function advanceStage() {
    if (props.hasOwnProperty('nextStage')) {
      props.nextStage(1);
    }
  }

  function prevStage() {
    if (props.hasOwnProperty('nextStage')) {
      props.nextStage(0);
    }
  }

  let mapOptions = [
    { value: 'beabloo', label: 'Beabloo' },
    { value: 'eyesite', label: 'Eyesite' },
  ];

  return (
    <div className='center justify-top'>
      <h1>Development Plots</h1>
      <div className='form-center small-button'>
        <p>Upload a CSV of your plots / or you can do this later.</p>
        <Form
          inputs={[
            {
              name: 'map-type',
              label: 'Upload CSV',
              type: 'select',
              options: mapOptions,
            },
          ]}
          onChange={handleFormChange}
        />

        <div className='button-group'>
          <button className='button button-gray' onClick={prevStage}>
            Back
          </button>
          <button className='button button-primary' onClick={advanceStage}>
            Finish
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlotsUpload;
